import {Component, Inject, OnInit, Optional} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LookupService} from '../../_services/lookup.service';
import {Lookup} from '../../_model/Lookup';
import {FormBuilder, FormGroup, ValidationErrors, Validators, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import { Requests } from 'src/app/_model/Requests';
import {ToastrService} from 'ngx-toastr';
import {RequestService} from '../../_services/request.service';
import {RequestsRequest} from '../../_model/request/RequestsRequest';
import {AppConstants, DIALOG_OPERATIONS} from '../../_utils/constants';
import {FileNameData} from '../../_model/FileNameData';
import {DialogCloseData} from "../../_model/models";
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {UtilityService} from '../../_helpers/utility.service';
import {EmployeeService} from '../../_services/employee.service';
import {MAT_DIALOG_DATA, MatDialogModule} from "@angular/material/dialog";
import {User} from "../../_model/user";
import {WfApproveRequest} from "../../_model/request/WfApproveRequest";
import {operations} from "../../_model/constants";
import {AuthenticationService} from "../../_services/authentication.service";
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonModule} from '@angular/material/button';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

@Component({
  selector: 'app-requestmodal',
  templateUrl: './requestmodal.component.html',
  styleUrls: ['./requestmodal.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatAutocompleteModule
  ]
})
export class RequestmodalComponent implements OnInit {
    request: WfApproveRequest = new WfApproveRequest();
    lookupForCurrentRequest: Lookup;
    currentUser: User;
    submitted = false;
    operationName: string;
  constructor(private lookupService: LookupService,
              private requestService: RequestService,
              private formBuilder: FormBuilder,
              private toastr: ToastrService,
              private authService: AuthenticationService,
              private utilityService: UtilityService,
              private employeeService: EmployeeService,
              public dialogRef: MatDialogRef<RequestmodalComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: Requests) { }

  reqClassList: Lookup[];
  tcNoList: any;
  reqTypeList: Lookup[];
  filteredReqTypeList: Lookup[] = [];
  selectedReqTypeList: Lookup[];
  selectedReqClassId: number;
  submitButtonName = 'Kaydet';
  requestUpdateRequest: RequestsRequest;
  requestRequest: RequestsRequest;
  fileList: FileNameData[] = [];
  // file upload variables
  fileData: File = null;
  fileUploadProgress: string = null;

  // calisan listesi
  filteredEmployeeList: Observable<any[]>;
  employees: any;
  talepSikayetId = AppConstants.REQUEST_TALEP_SIKAYET;

  requestForm: FormGroup = this.formBuilder.group({
          reqClassId: ['', [Validators.required]],
          reqTypeId: ['', ],
          subject: ['', [Validators.required]],
          description: ['', [Validators.required]],
          employee: ['', this.utilityService.requireMatch],
  });

  ngOnInit() {
    this.reqClassList = this.lookupService.localListByLookupCode('REQ_CLASS');
    this.reqTypeList = this.lookupService.localListByLookupCode('REQ_TYPE');
    this.employeeService.getEmployee().subscribe(result => {
      this.employees = result.responseData.items.sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'tr')
      );
      this.filteredEmployeeList = this.requestForm.get('employee').valueChanges
          .pipe(
              startWith(''),
              map(value => this.filterEmployeeList(value))
          );
  },
  error => {
      this.toastr.error(error.error.msg, 'Hata');
    });
    if (Object.keys(this.data).length === 0){
        this.operationName = operations.CREATE;
    } else {
        this.operationName = operations.UPDATE;
        this.requestForm.patchValue( {
            reqClassId: this.data.reqClass.id,
            reqTypeId: this.data.reqType.id,
            subject: this.data.subject,
            description: this.data.description,
            employee: this.data.employee,
            fileList: this.fileList,
            id: this.data.id,
            status: '',
            attribute1: '',
            attribute2: '',
            attribute3: '',
            attribute4: '',
            attribute5: '',
        });
        this.selectedReqClassId = this.data.reqClass.id;
        this.reqClassChanged();
    }
  }

    createOrUpdateAbsence() {
        this.submitted = true;
        if (this.requestForm.invalid) {
            this.getFormValidationErrors();
            return;
        }
        if (this.operationName === operations.UPDATE) {
            this.update();
        } else {
            this.create();
        }
    }

  reqClassChanged() {
      this.filteredReqTypeList = this.reqTypeList.filter(reqType => reqType.parentLookup.id === this.selectedReqClassId);
      if (this.selectedReqClassId === AppConstants.REQUEST_TALEP_SIKAYET) {
          this.requestForm.get('employee').disable();
      } else {
          this.requestForm.get('employee').enable();
      }
  }
    approveRequest() {
        // dosya yukleme zorunlulugu sadece ik icin gecerli
        if (this.currentUser.department.id === 3) {
            if (this.lookupForCurrentRequest.attribute5 != null && this.fileList.length === 0){
                this.toastr.error(this.lookupForCurrentRequest.attribute5 + ' dosyası yüklenmelidir', 'Hata');
                return;
            }
        }

        if (this.fileList.length > 0){
            this.request.fileList = this.fileList;
        }

        this.request.employeeId = this.currentUser.employeeId;
        this.request.operationRecordId = this.data.id;
        this.request.operationTableName = 'ABSENCE';
        this.requestService.approveRequests(this.request).subscribe(result => {
            this.toastr.success('Onaylama işlemi başarılı', '');
            this.dialogRef.close(true);
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close(false);
        });
    }

    update() {
        this.requestUpdateRequest = {
            reqClassId : this.requestForm.get('reqClassId').value,
            reqTypeId: this.requestForm.get('reqTypeId').value,
            subject: this.requestForm.get('subject').value,
            description: this.requestForm.get('description').value,
            employeeId: this.requestForm.get('employee').value.id,
            fileList: this.fileList,
            id: this.data.id,
            status: '',
            attribute1: '',
            attribute2: '',
            attribute3: '',
            attribute4: '',
            attribute5: '',
        };
        this.requestService.updateRequests(this.requestUpdateRequest).subscribe(result => {
            this.toastr.success('Güncelleme işlemi başarılı', '');
            this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.UPDATE , result.responseData.item ));
        }, error => {
            this.toastr.error(error.error.msg, 'Hata');
            this.dialogRef.close();
        });
    }

  create() {

    this.submitButtonName = 'Kaydediliyor...';
    this.requestForm.disable();

    this.requestRequest = this.requestForm.getRawValue();
    /**
     * yukarida this.requestForm.getRawValue() kodu sayfadaki employee elemanini requestRequeste
     * oldugu gibi gomdugu icin alt satirda ilgili attribute u yok ediyoruz mecbur!!!
     */
    if (this.requestRequest.hasOwnProperty('employee')) {
        delete this.requestRequest['employee'];
    }
    if (this.requestRequest.hasOwnProperty('employee1')) {
          delete this.requestRequest['employee1'];
      }
    this.requestRequest.fileList = this.fileList;

    if (this.selectedReqClassId !== AppConstants.REQUEST_TALEP_SIKAYET &&
        (this.requestForm.get('employee').value === '' || this.utilityService.requireMatch(this.requestForm.get('employee')) != null)) {
        this.toastr.warning('Çalışan seçilmelidir', 'Uyarı');
        return;
    }
    if (this.requestForm.get('employee').value !== '') {
        this.requestRequest.employeeId = this.requestForm.get('employee').value.id;
    }
    if (this.fileList.length > 2) {
        this.toastr.warning('En fazla 2 dosya yükleyebilirsiniz', '');
        return;
    }

    this.requestService.saveRequests(this.requestRequest).subscribe(saveResult => {
        this.toastr.success('Kaydetme işlemi başarılı', '');
        this.dialogRef.close(new DialogCloseData(DIALOG_OPERATIONS.CREATE, saveResult.responseData.item));
    }, error2 => {
        this.toastr.error(error2.error.msg, 'Hata');
        this.dialogRef.close();
        this.submitButtonName = 'Kaydet';
        this.requestForm.reset();
        this.requestForm.enable();
    }, () => {
        this.submitButtonName = 'Kaydet';
        this.requestForm.reset();
        this.requestForm.enable();
    });
  }

  closeModal() {
      this.dialogRef.close();
  }

  fileProgress(fileInput: any) {
      this.fileData = fileInput.target.files[0];
  }

  uploadFile() {
      const formData = new FormData();
      formData.append('file', this.fileData);

      const fileSizeInMb = this.fileData.size / 1024 / 1024;
      if (fileSizeInMb >= 2) {
          alert('Dosya boyutu en fazla ' + AppConstants.FILE_UPLOAD_LIMIT + 'mb olmalıdır');
          this.fileData = null;
          return;
      }

      this.getBase64(this.fileData).then(value => {
          this.fileList.push(new FileNameData(this.fileData.name, value));
      });

      setTimeout(() => this.fileData = null, 500);
  }

  deleteFile(index: number) {
      this.fileList.splice(index, 1);
  }

  getBase64(file) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
      });
  }

  private filterEmployeeList(value: any): string[] {
      let filterValue = '';
      if (value.hasOwnProperty('name')) {
          filterValue = this.utilityService.toTurkishLowerCase(value.name + ' ' + value.surname);
      } else {
          filterValue = this.utilityService.toTurkishLowerCase(value);
      }
      return this.employees.filter(employee => this.utilityService.toTurkishLowerCase(employee.name + ' ' + employee.surname).includes(filterValue));
    }

  displayFn(employee: any): string | undefined {
      return employee ? employee.name + ' ' + employee.surname : undefined;
  }
    getFormValidationErrors() {
        Object.keys(this.requestForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.requestForm.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });
    }

}
